import { ScreenSources } from '@walter/shared/constants/posthog'
import { Transaction } from '@web/walter-lib/api'
import { SwapPageLocationState } from '~pages/SwapPage/types'
import { ActionDisabledReason } from '~types'

export enum ModalTypes {
    staking = 'staking',
    referral = 'referral',
    assetLimits = 'assetLimits',
    authRequired = 'authRequired',
    walletID = 'walletID',
    locale = 'locale',
    baseCurrency = 'baseCurrency',
    transactionDetails = 'transactionDetails',
    migration = 'migration',
    newVirtualCard = 'newVirtualCard',
    socialReferral = 'socialReferral',
}

export interface AssetLimitsModalPayload {
    disabledReason?: ActionDisabledReason
    screenSource?: ScreenSources
}

export interface StakingModalPayload {
    type?: 'enable' | 'disable'
}

export interface TransactionDetailsModalPayload {
    tx?: Transaction
    onActionClick?: () => void
    swapPageLocationState?: SwapPageLocationState
}

export interface ModalPayloads {
    [ModalTypes.staking]?: StakingModalPayload
    [ModalTypes.referral]?: undefined
    [ModalTypes.assetLimits]?: AssetLimitsModalPayload
    [ModalTypes.authRequired]?: undefined
    [ModalTypes.walletID]?: undefined
    [ModalTypes.locale]?: undefined
    [ModalTypes.baseCurrency]?: undefined
    [ModalTypes.transactionDetails]?: TransactionDetailsModalPayload
    [ModalTypes.migration]?: undefined
    [ModalTypes.newVirtualCard]?: undefined
    [ModalTypes.socialReferral]?: {
        showSuccessView?: boolean
    }
}

export type Modals = Array<{
    type: ModalTypes
    data?: ModalPayloads[keyof ModalPayloads]
    isOpen: boolean
}>
